import React, { useRef, useState, useEffect } from "react";
import Resizer from 'react-image-file-resizer';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toggleVideoActivity } from "../../../../redux/slices/activityCategories";
import { updateVideo } from "../../../../redux/slices/duonutSettings";
import { updateImage, updateContainerImage, updateMtfOptionImage, toggleVideoVisible } from "../../../../redux/slices/userActivity";
import { getFileSizeFromBase64 } from "../../../../utils";

export default function Upload({ video }) {
  const inputRef = useRef(null);
  const { userActivities, selectedUserActivity, selectedComponent } = useSelector((state) => state.userActivity);
  const dispatch = useDispatch();
  const [image, setImage] = useState();

  const handleClick = () => {
    inputRef.current.click();
  };
  const openModal = () => dispatch(toggleVideoActivity())
  // console.log(userActivities)

  const handleVideoChange = async (e) => {
    // console.log(e.target.files[0])
    const file = e.target.files[0]
    dispatch(updateVideo({video: file}))
    dispatch(toggleVideoVisible({ videoVisible: true }))
  }
  const updateActivityImage = async (e) => {
    if (selectedComponent.name === "image") {
      const imageFile = e.target.files[0];
      if (imageFile.type === "image/png") {
        Resizer.imageFileResizer(
          imageFile,
          1000,
          1000,
          'PNG',
          90,
          0,
          uri => {
            dispatch(
              updateImage({
                selectedActivityIdx: selectedUserActivity,
                name: e.target.files[0].name,
                uri: uri,
              })
            );
            getFileSizeFromBase64(uri)
          },
          'base64'
        );
      } else {
        Resizer.imageFileResizer(
          imageFile,
          1000,
          1000,
          'JPEG',
          90,
          0,
          uri => {
            dispatch(
              updateImage({
                selectedActivityIdx: selectedUserActivity,
                name: e.target.files[0].name,
                uri: uri,
              })
            );
            getFileSizeFromBase64(uri)
          },
          'base64'
        );
      }
      // var reader = new FileReader();
      // reader.onloadend = function () {
      //   // adds image_data in question_id
      //   dispatch(
      //     updateImage({
      //       selectedActivityIdx: selectedUserActivity,
      //       name: e.target.files[0].name,
      //       uri: reader.result,
      //     })
      //   );
      //   // getFileSizeFromBase64(reader.result)
      // };
      // reader.readAsDataURL(e.target.files[0]);
    }
    if (selectedComponent.name === "container") {
      const imageFile = e.target.files[0];
      if (imageFile.type === "image/png") {
        Resizer.imageFileResizer(
          imageFile,
          1000,
          1000,
          'PNG',
          90,
          0,
          uri => {
            dispatch(
              updateContainerImage({
                selectedActivityIdx: selectedUserActivity,
                name: e.target.files[0].name,
                uri: uri,
              })
            );
            getFileSizeFromBase64(uri)
          },
          'base64'
        );
        return;
      }
      Resizer.imageFileResizer(
        imageFile,
        1000,
        1000,
        'JPEG',
        90,
        0,
        uri => {
          dispatch(
            updateContainerImage({
              selectedActivityIdx: selectedUserActivity,
              name: e.target.files[0].name,
              uri: uri,
            })
          );
          getFileSizeFromBase64(uri)
        },
        'base64'
      );
      // var reader = new FileReader();
      // reader.onloadend = function () {
      //   // adds background_image_data in question_id
      //   dispatch(
      //     updateContainerImage({
      //       selectedActivityIdx: selectedUserActivity,
      //       name: e.target.files[0].name,
      //       uri: reader.result,
      //     })
      //   );
      // };
      // reader.readAsDataURL(e.target.files[0]);

    }

    if (selectedComponent.name === "mtf_option_image") {
      const imageFile = e.target.files[0];
      if (imageFile.type === "image/png") {
        Resizer.imageFileResizer(
          imageFile,
          1000,
          1000,
          'PNG',
          90,
          0,
          uri => {
            dispatch(
              updateMtfOptionImage({
                selectedActivityIdx: selectedUserActivity,
                selectedOptionId: selectedComponent.optionId,
                updatedImageData: {
                  l_image_data: {
                    name: e.target.files[0].name,
                    uri: uri,
                  },
                },
              })
            );
            getFileSizeFromBase64(uri)
          },
          'base64'
        );
        return;
      }
      Resizer.imageFileResizer(
        imageFile,
        1000,
        1000,
        'JPEG',
        90,
        0,
        uri => {
          dispatch(
            updateMtfOptionImage({
              selectedActivityIdx: selectedUserActivity,
              selectedOptionId: selectedComponent.optionId,
              updatedImageData: {
                l_image_data: {
                  name: e.target.files[0].name,
                  uri: uri,
                },
              },
            })
          );
          getFileSizeFromBase64(uri)
        },
        'base64'
      );
      // var reader = new FileReader();
      // reader.onloadend = function () {
      //   dispatch(
      //     updateMtfOptionImage({
      //       selectedActivityIdx: selectedUserActivity,
      //       selectedOptionId: selectedComponent.optionId,
      //       updatedImageData: {
      //         l_image_data: {
      //           name: e.target.files[0].name,
      //           uri: reader.result,
      //         },
      //       },
      //     })
      //   );
      // };
      // reader.readAsDataURL(e.target.files[0]);

    }
  };

  return (
    <div className="text_editor_item text_editor_button d-flex" onClick={handleClick}>
      <img src="/assets/icons/upload-image.svg" />
      Upload
      <input type="file" ref={inputRef}
        onChange={(e) =>video ? handleVideoChange(e) : updateActivityImage(e)}
        accept={video ? 'video/*' : "image/*"}
        onClick={(e) => { e.target.value = null }} name="postImages" style={{ display: "none" }} />
    </div>
  );
}
